import { render, staticRenderFns } from "./OtrasOpciones.vue?vue&type=template&id=5b167460&"
import script from "./OtrasOpciones.vue?vue&type=script&lang=js&"
export * from "./OtrasOpciones.vue?vue&type=script&lang=js&"
import style0 from "./OtrasOpciones.vue?vue&type=style&index=0&id=5b167460&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports